import { useChatStore } from "./chat-store-context";

export const useMessages = () => useChatStore((s) => s.messages);
export const usePartsMap = () => useChatStore((s) => s.partsMap);
export const useStreaming = () => useChatStore((s) => s.streaming);
export const useAppState = () => useChatStore((s) => s.appState);
export const useActiveSessionId = () => useChatStore((s) => s.activeSessionId);
export const usePendingTools = () => useChatStore((s) => s.pendingTools);
